export default "__VITE_ASSET__C_lyhzi___"